import { Button, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

const FloatingDonateButton = () => {
  const theme = useTheme();

  return (
    <Button
      component={Link}
      to="/donate"
      variant="contained"
      color="secondary"
      startIcon={<VolunteerActivismIcon />}
      sx={{
        position: 'fixed',
        bottom: { xs: 80, md: 100 }, // Adjusted to move the button upward
        right: { xs: 20, md: 40 },
        borderRadius: '50px',
        padding: '12px 24px',
        fontSize: { xs: '0.9rem', md: '1rem' },
        fontWeight: 600,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: theme.zIndex.speedDial,
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
        },
        transition: 'all 0.3s ease',
      }}
    >
      Donate Now
    </Button>
  );
};

export default FloatingDonateButton;
